module.exports = __webpack_public_path__ + "static/patient_dr_serie_12-1985.444ecf7a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/images/project2/patient_dr_serie_12-1985.jpg
// module id = 497
// module chunks = 8418805283199